import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, GatsbyImageProps } from "gatsby-plugin-image"
import { StrapiImageItem } from "_types/AssetsImage"

interface ImageProps extends Omit<GatsbyImageProps, "image"> {
  image: StrapiImageItem
}

export const Image = ({ image, ...rest }: ImageProps) => {
  if (image.localFile) {
    const finalImage = image.localFile.childImageSharp?.gatsbyImageData
    return (
      <GatsbyImage {...rest} image={finalImage} className={rest.className} />
    )
  }
  return (
    <img
      src={image.url}
      alt={image.alternativeText}
      loading="lazy"
      className={rest.className}
    />
  )
}

export const strapiBaseImageFragment = graphql`
  fragment StrapiBaseImageFragment on STRAPI__MEDIA {
    id
    alternativeText
    url
    name
    height
    width
  }
`

export const strapiImageFragment = graphql`
  fragment StrapiImageFragment on STRAPI__MEDIA {
    ...StrapiBaseImageFragment
    localFile {
      childImageSharp {
        gatsbyImageData(
          avifOptions: { lossless: true, quality: 80, speed: 10 }
          webpOptions: { quality: 80 }
          layout: CONSTRAINED
          blurredOptions: { toFormat: AUTO }
          formats: [AUTO, AVIF, WEBP]
        )
      }
    }
  }
`
